import Api from "entities/helpers/api";
import EverTrue from "app";
import ErrorLogger from "entities/helpers/error-log-helper";
import journeysQueries from "../gql/queries";
import { fetchFromGraphql } from "entities/helpers/gqlCall";

export const bulkFetchContactsForJourney = async (contactIds) => {
  const query = journeysQueries.fetchContacts;

  const params = { ids: contactIds };
  const { contacts } = await fetchFromGraphql(query, params, "contacts");

  return contacts;
};

export const moveConstituentToJourney = async (oldJourneyId, contactId, userId, oid, newJourneyId, newJourneyLabel) => {
  const payload = {
    contact_id: contactId,
    user_id: userId,
    oid: oid,
  };
  if (newJourneyId) payload.new_journey = { id: newJourneyId };
  if (oldJourneyId)
    payload.old_journey = {
      id: oldJourneyId,
      reason: newJourneyId ? "SKIPPED_MOVED_JOURNEY" : "SKIPPED_REMOVED_FROM_JOURNEY",
    };
  await Api.JOURNEYS.CONTACT_JOURNEY.post({
    data: JSON.stringify(payload),
    success: () => {
      if (payload.new_journey) {
        return EverTrue.Alert.success(`Successfully moved constituent into ${newJourneyLabel} cadence.`);
      }
      return EverTrue.Alert.success("Successfully removed constituent from cadence.");
    },
    error: (e) => {
      ErrorLogger.error("Error moving constituent", { extra: { error: e, page_name: "Cadences" } });
    },
  });
};

// TO DO: Update to a bulk add endpoint
export const bulkAddConstituentsToJourney = async (contactId, userId, oid, newJourneyId) => {
  const payload = {
    contact_id: contactId,
    user_id: userId,
    oid: oid,
    new_journey: { id: newJourneyId },
  };
  await Api.JOURNEYS.CONTACT_JOURNEY.post({
    data: JSON.stringify(payload),
  });
};

export const getContactJourney = async (contactId) => {
  try {
    return await Api.JOURNEYS.GET_CONTACT_JOURNEY.get({
      urlArgs: { contact_id: contactId },
    });
  } catch (e) {
    ErrorLogger.error("Error fetching Contact's Journey details", { extra: { error: e, page_name: "Profile Header" } });
  }
};
